import styled from "styled-components";

export const AboutContainer = styled.div`
    text-align: center;
    width: 70%;
    margin: 0 auto;

    @media (max-width: 900px) {
        width: 85%;
    }

    @media (max-width: 499px) {
        width: 90%;
    }
`;

export const AboutTitle = styled.h1`
    font-weight: 700;
    font-style: Regular;
    font-size: 108px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;

    @media (max-width: 900px) {
        font-size: 84px;
    }

    @media (max-width: 499px) {
        font-size: 54px;
    }
`

export const AboutSubtitle = styled.h2`
    font-family: Open Sans;
    font-weight: 700;
    font-style: Bold;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    margin-bottom: 48px;

    @media (max-width: 900px) {
        font-size: 22px;
    }

    @media (max-width: 499px) {
        font-size: 16px;
    }
`

export const AboutContent = styled.p`
    font-family: Open Sans;
    font-weight: 300;
    font-style: Light;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    margin: 10px;

    @media (max-width: 900px) {
        font-size: 22px;
    }

    @media (max-width: 499px) {
        font-size: 14px;
    }
`;

